import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/common.json";
import translationAR from "./locales/ar/common.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
	en: {
		translation: translationEN,
	},
	ar: {
		translation: translationAR,
	},
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		fallbackLng: "en",
    	// lng: localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : "ar" ,
    	lng: localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : "en" ,
		// detection: {
		// 	order: [
		// 		// "querystring",
		// 		// "cookie",
		// 		"localStorage",
		// 		"sessionStorage",
		// 		"navigator",
		// 		"htmlTag",
		// 		"path",
		// 		"subdomain",
		// 	],

		// 	// keys or params to lookup language from
		// 	caches: ["localStorage"],
		// },
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
